import { createStyles } from '@mantine/styles';


export default createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    colorScheme: any;
}) => ({

    nightBadgeBooking: {
        position: 'absolute',
        right: 0,
        top: 0,
    },

    minBadgeTitle: {
        textTransform: 'uppercase',
        textAlign: 'center',
        fontSize: 10,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 8,
        paddingRight: 8,
        background: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[3],
        color: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[6],
        borderBottomLeftRadius: theme.radius.xs,
        borderTopRightRadius: theme.radius.xs,
        letterSpacing: 1,
        lineHeight: 1.2,
    },

    minBadgeText: {
        display: 'inline-flex',
        textTransform: 'uppercase',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 200,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
        // borderColor: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[4],
        // borderWidth: 1,
        // borderStyle: 'solid',
        // borderBottomLeftRadius: theme.radius.xs,
        // borderBottomRightRadius: theme.radius.xs,
    },

    icon: {
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
        marginLeft: 6,
        fontSize: 24,
    },

}));
